@if (displayToggle && courses.length && !isArchivedCourses()) {
  <div class="demo-toggle-container">
    <div class="button-container">
      <button mat-flat-button (click)="click()" [disabled]="teacherBtnDisabled" [ngClass]="teacherBtnClass">Teacher View</button>
      <button mat-flat-button (click)="click()" [disabled]="studentBtnDisabled" [ngClass]="studentBtnClass">Student View</button>
    </div>
  </div>
}
